import { makeQueryClient } from "@r-and-a-shared-ui/randa-trpc-server/query-client";
import { QueryClient } from "@tanstack/react-query";

export const getQueryClient = (clientQueryClientSingleton?: QueryClient) => {
  if (typeof window === 'undefined') {
    // Server: always make a new query client
    return makeQueryClient();
  }

  // Browser: use singleton pattern to keep the same query client
  return (clientQueryClientSingleton ??= makeQueryClient());
};
